import PrettyPage from '@/pages/pretty/layout.vue'
import IndexPage from '@/pages/pretty/index.vue'

const routes = {
	path: '/pretty',
	component: PrettyPage,
	children: [
		{
			path: '',
			component: IndexPage,
			meta: {title: 'Сокращатель ссылок'}
		}
	]
}
export default {
	routes
}



// WEBPACK FOOTER //
// ./src/routes/pretty.js